/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Delete_Confirm_DescriptionInputs */

const he_account_reviews_delete_confirm_description = /** @type {(inputs: Account_Reviews_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעולה זו תמחק את הביקורת שלך על מוצר זה לצמיתות.`)
};

const en_account_reviews_delete_confirm_description = /** @type {(inputs: Account_Reviews_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently remove your review for this item.`)
};

/**
* | output |
* | --- |
* | "This will permanently remove your review for this item." |
*
* @param {Account_Reviews_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_delete_confirm_description = /** @type {((inputs?: Account_Reviews_Delete_Confirm_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Delete_Confirm_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_delete_confirm_description(inputs)
	return en_account_reviews_delete_confirm_description(inputs)
});